export class UpdateMongoAtlasRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpRestoreAccountId",
            "baseName": "gcpRestoreAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "azureRestoreAccountId",
            "baseName": "azureRestoreAccountId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return UpdateMongoAtlasRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
